<template>
    <main-layout>
        <div id="dashboard" class="page animated fadeIn">
            <v-row>
                <v-col cols="12">
                    <h1 class="mb-0">Dashboard</h1>
                </v-col>
                <v-col cols="12" lg="6">
                    <v-card class="pa-4">
                        <em>Dashboard is under construction</em>
                    </v-card>
                </v-col>
                <v-col cols="12" lg="6">
                    <v-card class="pa-4">
                        <em>Here will be some useful cards</em>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/MainLayout.vue';

export default {
  components: {
    MainLayout,
  },
  name: 'Dashboard',
};
</script>

<style lang="sass"></style>
